import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Volví a sentirme bien conmigo mismo',
  text: 'Siempre empezaba rutinas y abandonaba a la semana. Con Entrena en Casa pude mantenerme constante por primera vez. Hoy tengo más energía, bajé varios kilos y me siento muchísimo más seguro.',
  name: 'Nicolás M.',
  location: 'Buenos Aires',
  initials: 'NM'
}, {
  quote: 'Me ayudó a crear disciplina de verdad',
  text: 'No es solo ejercicio. Cambió mi mentalidad completamente. Ahora tengo hábitos mucho más saludables y ya no me siento agotada todo el tiempo.',
  name: 'Camila R.',
  location: 'Córdoba',
  initials: 'CR'
}, {
  quote: 'Perfecto para personas ocupadas',
  text: 'Trabajo todo el día y no tenía tiempo para ir al gimnasio. Este sistema me ayudó a organizarme y entrenar desde mi casa sin complicarme.',
  name: 'Matías F.',
  location: 'Rosario',
  initials: 'MF'
}];
export function Testimonials() {
  return <section className="py-8 md:py-16 px-4 bg-zinc-900/50 border-y border-zinc-800/50" data-id="element-206">
      <div className="max-w-6xl mx-auto" data-id="element-207">
        {/* Mobile: horizontal scroll snap. Desktop: grid */}
        <div className="flex md:grid md:grid-cols-3 gap-3 md:gap-6 overflow-x-auto md:overflow-visible snap-x snap-mandatory -mx-4 px-4 md:mx-0 md:px-0 pb-2 md:pb-0 scrollbar-none" data-id="element-208">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} whileTap={{
          scale: 0.98
        }} className="bg-zinc-900 border border-zinc-800 p-4 md:p-6 rounded-2xl relative snap-center shrink-0 w-[85%] md:w-auto" data-id="element-209">
              <Quote className="absolute top-3 right-3 w-6 h-6 text-zinc-800" data-id="element-210" />
              <div className="flex gap-0.5 mb-2" data-id="element-211">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 text-brand-500 fill-brand-500" data-id="element-212" />)}
              </div>
              <h3 className="text-sm md:text-lg font-bold text-white mb-1.5" data-id="element-213">
                "{t.quote}"
              </h3>
              <p className="text-zinc-400 text-xs md:text-sm mb-4 leading-relaxed line-clamp-4 md:line-clamp-none" data-id="element-214">
                "{t.text}"
              </p>
              <div className="flex items-center gap-2.5" data-id="element-215">
                <div className="w-8 h-8 md:w-10 md:h-10 rounded-full bg-brand-500/20 text-brand-500 flex items-center justify-center font-bold text-xs md:text-sm border border-brand-500/30" data-id="element-216">
                  {t.initials}
                </div>
                <div data-id="element-217">
                  <div className="font-bold text-white text-xs md:text-sm" data-id="element-218">
                    {t.name}
                  </div>
                  <div className="text-[10px] md:text-xs text-zinc-500" data-id="element-219">
                    {t.location}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}